export enum SellerMarketplaceTab {
    MyEngagement = 1,
    EngagementDocuments = 2,
    EngagementTimeline = 3,
    Buyers = 4,
    DeadlineDocket = 5,
    DataAndDocs = 6,
    Settings = 7,
    CommsHub = 8,
    EngagementHistory = 9,
    SellerProfile = 10,
    DataRoomLayout = 11,
    VDRAccess = 12,
}

export const SellerMarketplaceTabs = [
    { id: SellerMarketplaceTab.MyEngagement, label: 'My Engagement' },
    {
        id: SellerMarketplaceTab.EngagementDocuments,
        label: 'Engagement Documents',
    },
    {
        id: SellerMarketplaceTab.EngagementTimeline,
        label: 'Engagement Timeline',
    },
    { id: SellerMarketplaceTab.Buyers, label: 'Buyers' },
    { id: SellerMarketplaceTab.DeadlineDocket, label: 'Deadline Docket' },
    { id: SellerMarketplaceTab.DataAndDocs, label: 'Practice Data & Docs' },
    { id: SellerMarketplaceTab.Settings, label: 'Settings' },
    { id: SellerMarketplaceTab.CommsHub, label: 'Comms Hub' },
    {
        id: SellerMarketplaceTab.EngagementHistory,
        label: 'Engagement History',
    },
    { id: SellerMarketplaceTab.SellerProfile, label: 'Seller Profile' },
    { id: SellerMarketplaceTab.DataRoomLayout, label: 'Data Room' },
    { id: SellerMarketplaceTab.VDRAccess, label: 'VDR Access' },
];
